const isRepoActive = (repo) => !repo?.repo_complete;

export default isRepoActive;
